import axios from "axios"
import { API_BASE_URL } from "@/config/api"
// 查询菜单
export const queryMenu = ()=>{
 return axios.get(`${API_BASE_URL}/app/menu/queryMenu`)
}
// 页面数据
export const queryMenuContent = (id)=>{
    return axios.get(`${API_BASE_URL}/app/menu/queryMenuContent?parentId=${id}`)
}
